module.exports = __webpack_public_path__ + "img/mgh-otemachi-sp.14db67be.jpg";